import React, { useEffect, useState } from "react";
import { Modal, Form, Select, Input, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const DocumentForm = ({ visible, setVisible, id, fetchDocuments, isEditMode, documentId, list, setVisits, verification }) => {
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      if (fileList.length > 0) {
        formData.append("file", fileList[0]);
      }

      formData.append("Tipo", values.Tipo);

      const response = await axios({
        method: isEditMode ? "put" : "post",
        url: isEditMode
          ? `${process.env.REACT_APP_API_URL}/documentos/${documentId}`
          : `${process.env.REACT_APP_API_URL}/documentos/${id}/upload`,
        data: formData,
      });

      // Check if Tipo matches the string to trigger the update
      if (values.Tipo === "Acta de evaluación de la conformidad") {
        console.log("bloquear");
        await axios.put(`${process.env.REACT_APP_API_URL}/visitas/bloquear/${id}`);

        // Fetch updated data after blocking
        axios
          .get(`${process.env.REACT_APP_API_URL}/visitas/${id}`)
          .then((res) => {
            setVisits(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }

      message.success("Documento subido con éxito");
      fetchDocuments();
      setVisible(false);

      const truncatedTipo = values.Tipo.length > 20 ? `${values.Tipo.slice(0, 20)}...` : values.Tipo;

      axios.post(`${process.env.REACT_APP_API_URL}/notificaciones/directores`, {
        Mensaje: `Se cargó ${truncatedTipo} a la verificación ${verification.ControlInterno}`,
        Estado: 0, // Unread
        TargetURL: `/verificaciones/${verification.VerificacionID}`,
      });

      message.success("Notificación enviada a directores");
    } catch (error) {
      message.error("Error al subir el documento");
    }
  };

  const handleFailedSubmit = (errorInfo) => {
    message.error("Asegúrate de llenar todos los campos");
  };

  useEffect(() => {
    if (visible) {
      form.resetFields();
      setFileList([]); // Clear the file list when modal opens
    }
  }, [visible, form]);

  return (
    <Modal title={isEditMode ? "Editar documento" : "Subir documento"} visible={visible} onCancel={() => setVisible(false)} footer={null}>
      <Form form={form} layout="vertical" onFinish={handleSubmit} onFinishFailed={handleFailedSubmit}>
        <Form.Item label="Tipo de documento" name="Tipo" rules={[{ required: true, message: "Por favor selecciona el tipo de documento" }]}>
          <Select placeholder="Seleccionar tipo de documento" allowClear showSearch>
            {list?.map((type) => (
              <Select.Option key={type} value={type}>
                {type}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Seleccionar archivo"
          name="file"
          rules={[{ required: !isEditMode, message: "Por favor selecciona un archivo para subir" }]}
          hidden={isEditMode}
        >
          <Upload
            name="file"
            maxCount={1}
            beforeUpload={(file) => {
              setFileList([file]);
              return false; // Prevent default upload
            }}
            fileList={fileList}
          >
            <Button icon={<UploadOutlined />}>Seleccionar archivo</Button>
          </Upload>
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Guardar
        </Button>
      </Form>
    </Modal>
  );
};

export default DocumentForm;
